export default "__VITE_ASSET__BIIs33dh__"